import { DateTime } from "luxon";

export const formatReservationDateTime = (startHour) => {
  const formattedDate = DateTime.fromISO(startHour, { zone: "utc" })
    .setZone("America/Sao_Paulo") // Convert to São Paulo timezone
    .toFormat("dd/MM/yyyy 'às' HH:mm"); // Format as "DD/MM/YYYY às HH:MM"

  return formattedDate;
};

export const formatDateLabel = (reservationDate, type) => {
  // Convert UTC date to America/Sao_Paulo timezone
  const reservationDateObj = DateTime.fromISO(reservationDate, { zone: "utc" })
    .setZone("America/Sao_Paulo")
    .startOf("day");

  const today = DateTime.now().setZone("America/Sao_Paulo").startOf("day");
  const yesterday = today.minus({ days: 1 });
  const tomorrow = today.plus({ days: 1 });

  const weekdays = [
    "DOMINGO",
    "SEGUNDA",
    "TERÇA",
    "QUARTA",
    "QUINTA",
    "SEXTA",
    "SÁBADO",
  ];

  let dateLabel;

  if (reservationDateObj.equals(yesterday)) {
    dateLabel = "ONTEM";
  } else if (reservationDateObj.equals(tomorrow)) {
    dateLabel = "AMANHÃ";
  } else {
    dateLabel = weekdays[reservationDateObj.weekday % 7]; // Ensure correct weekday mapping
  }

  const typeLabel = type === "entry" ? "ENTRADA" : "SAÍDA";

  return `${dateLabel} - ${typeLabel}`;
};
